import { safraRepository } from "@/services/database/repositories/SafraRepository";
// import { municipioUfRepository } from "@/services/database/repositories/MunicipioUfRepository";

export default {
  methods: {
    async buscarMunicipioUf() {
      try {
        const response = await this.$http.get("/api/astec/municipioUfLkp");

        // Ordena os dados
        const dadosOrdenados = response.data.sort((a, b) => {
          const textoA = a.REGIAO.replace(/^\d+\s*-\s*/, "").trim();
          const textoB = b.REGIAO.replace(/^\d+\s*-\s*/, "").trim();

          const aComecaComNumero = /^\d/.test(textoA);
          const bComecaComNumero = /^\d/.test(textoB);

          if (aComecaComNumero === bComecaComNumero) {
            return textoA.localeCompare(textoB, "pt-BR");
          }

          return aComecaComNumero ? 1 : -1;
        });

        this.selecaoMunicipioLkp = dadosOrdenados.map(municipio => ({
          name: municipio.REGIAO.trim(),
          value: municipio.VALUE
        }));
      } catch (err) {
        this.$tools.alerta("Erro ao carregar municípios", "error");
      }
    },

    async buscarLkpProjeto() {
      try {
        const response = await this.$http.get("/api/astec/getLkpProjeto");

        const projetosOrdenados = response.data.sort((a, b) => {
          return a.DISPLAY.localeCompare(b.DISPLAY, "pt-BR", {
            sensitivity: "base"
          });
        });

        this.selecaoProjetoLkp = projetosOrdenados.map(projeto => ({
          name: projeto.DISPLAY,
          value: projeto.ID
        }));
      } catch (err) {
        this.$tools.alerta(err.response.data.message, "error");
      }
    },

    async buscarLkpSafra() {
      try {
        const needsRefresh = await safraRepository.needsRefresh();

        if (needsRefresh) {
          const response = await this.$http.get("/api/astec/getLkpSafra");
          await safraRepository.bulkUpsert(response.data);
        }

        const safras = await safraRepository.findAll();

        // Mapeia para o formato que seu componente espera
        this.selecaoSafraLkp = safras.map(safra => ({
          name: safra.display, // "2024/2025"
          value: safra.idApi, // "1" (ou safra.value dependendo do que você usa)
          epoca: safra.tpepoca // "V"
        }));
      } catch (err) {
        // Fallback...
        const safras = await safraRepository.findAll();
        if (safras.length > 0) {
          this.selecaoSafraLkp = safras.map(safra => ({
            name: safra.display,
            value: safra.id,
            epoca: safra.tpepoca
          }));
        }
      }
    },
    async buscarLkpInstituicaoFinanc(cdCooperado) {
      try {
        const response = await this.$http.get(
          "/api/astec/getLkpInstituicaoFinanc/" + cdCooperado
        );
        this.instituicaoFinanceiraLkp = response.data.map(
          instituicaoFinanc => ({
            name: instituicaoFinanc.DISPLAY,
            value: instituicaoFinanc.ID
          })
        );
      } catch (err) {
        this.$tools.alerta(err.response.data.message, "error");
      }
    },

    async buscarLkpLinhaCredito() {
      try {
        const response = await this.$http.get("/api/astec/getLkpLinhaCredito");
        this.linhaCreditoLkp = response.data.map(linhaCredito => ({
          name: linhaCredito.DISPLAY,
          value: linhaCredito.ID
        }));
      } catch (err) {
        this.$tools.alerta(err.response.data.message, "error");
      }
    },

    async buscarLkpTipoProjeto() {
      try {
        const response = await this.$http.get("/api/astec/getLkpTipoProjeto");
        this.tipoProjetoLkp = response.data.map(tipoProjeto => ({
          name: tipoProjeto.DISPLAY,
          value: tipoProjeto.ID,
          perAstec: tipoProjeto.PER_ASTEC
        }));
      } catch (err) {
        this.$tools.alerta(err.response.data.message, "error");
      }
    },

    async buscarLkpItemAgropecuario() {
      try {
        const response = await this.$http.get(
          "/api/astec/getLkpItemAgropecuario"
        );
        this.itemAgropecuarioLkp = response.data.map(itemAgropecuario => ({
          name: itemAgropecuario.DISPLAY,
          value: itemAgropecuario.ID
        }));
      } catch (err) {
        this.$tools.alerta(err.response.data.message, "error");
      }
    },

    async buscarLkpModalidadeSeguro() {
      try {
        const response = await this.$http.get(
          "/api/astec/getLkpModalidadeSeguro"
        );
        this.selecaoModalidadeSeguroLkp = response.data.map(
          modalidadeSeguro => ({
            name: modalidadeSeguro.DISPLAY,
            value: modalidadeSeguro.ID
          })
        );
      } catch (err) {
        this.$tools.alerta(err.response.data.message, "error");
      }
    },

    async buscarLkpStatusProjeto() {
      try {
        const response = await this.$http.get("/api/astec/getLkpStatusProjeto");
        this.selecaoStatusProjetoLkp = response.data.map(statusProjeto => ({
          name: statusProjeto.DISPLAY,
          value: statusProjeto.ID
        }));
      } catch (err) {
        this.$tools.alerta(err.response.data.message, "error");
      }
    },

    async buscarLkpCooperado() {
      try {
        const response = await this.$http.get(
          "/api/astec/getLkpCooperadoProjeto"
        );
        this.cooperadoLkp = response.data.map(item => ({
          name: item.DISPLAY,
          value: item.ID
        }));
      } catch (err) {
        this.$tools.alerta(err.response.data.message, "error");
      }
    },

    async FiltrarClientesRurais() {
      const dados = {
        cliente: this.selecaoClienteRural
          ? this.selecaoClienteRural.value
          : null,
        cpf_cnpj: this.cpfCnpj || null,
        mes_ano_aniversario: this.mesAno ? this.mesAno.value : "",
        e_mail: this.email ? this.email.trim() : "",
        sq_regiao: this.selecaoMunicipio ? this.selecaoMunicipio.value : null,
        cd_projeto: this.selecaoProjeto ? this.selecaoProjeto.value : null,
        safra: this.selecaoSafra ? this.selecaoSafra.name : null
      };
      return dados;
    },

    async FiltrarProjetos(cdPessoa) {
      try {
        const response = await this.$http.get(
          "/api/astec/getProjetosClienteRural/" + cdPessoa
        );
        console.log(response.data, "RESPONSE");
        this.projetosListados = response.data;
      } catch (err) {
        this.$tools.alerta(err.response.data.message, "error");
      }
    },

    async getNomeRazaoUsuario() {
      try {
        const token = this.$store.state.access_token;
        const isErp = this.$store.state.user?.tipoUsuario === 'erp' || this.$store.state.me?.user_erp;
        const endpointMe = isErp ? "api/authErp/meErp" : "api/auth/me";
        const headerMe = { headers: { Authorization: `Bearer ${token}` } };
        const response = await this.$http.get(endpointMe, headerMe);
        this.cdPessoa = response.data.cd_pessoa;
      } catch (err) {
        console.log(err);
        this.logoutUser();
      }
    },

    async getClienteRuralFoto(sqClienteRural) {
      try {
        const response = await this.$http.get(
          `/api/astec/buscarFotoClietneRural/${sqClienteRural}`
        );
        return response.data?.nm_caminho_foto || null;
      } catch (error) {
        return null;
      }
    }
  }
};
